<template>
  <div
    ref="iconRef"
    :style="computedStyle"
    @click="handleClick"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { useDraggable } from "@vueuse/core";
import type { CSSProperties } from "vue";
import clamp from "lodash-es/clamp";

const props = defineProps({
  onClick: {
    type: Function,
    default: () => {},
  },
});
const touchEndTime = ref(0);
const iconRef = ref<any>(null);
const moved = ref(false);
let startX = 0;
let startY = 0;

const { x, y } = useDraggable(iconRef, {
  initialValue: { x: startX, y: startY },
  preventDefault: true,

  onStart: () => {
    moved.value = false;
  },

  onEnd: (e) => {
    const { x, y } = e;
    moved.value = Math.abs(x - startX) > 20 || Math.abs(y - startY) > 20;
    startX = x;
    startY = y;
  },
});

const computedStyle = computed(() => {
  const left = clamp(x.value, 20, window.innerWidth - 68);
  const top = clamp(y.value, 50, window.innerHeight - 98);

  return {
    position: "absolute",
    touchAction: "none",
    cursor: "pointer",
    left: `${left}px`,
    top: `${top}px`,
  } as CSSProperties;
});

const handleClick = (e) => {
  if (!moved.value) {
    e.preventDefault();
    props.onClick();
  }
};

const handleTouchStart = (e: TouchEvent) => {
  touchEndTime.value = Date.now();
};

const handleTouchEnd = (e: TouchEvent) => {
  const touchDuration = Date.now() - touchEndTime.value;
  // 如果没有明显的移动且触摸时间较短，则认为是点击
  if (touchDuration < 350) {
    props.onClick();
  }
};
</script>
